import React from 'react';
import { Loader2, Check } from 'lucide-react';

interface BulkImportFooterProps {
  hasRows: boolean;
  totalValid: number;
  totalErrors: number;
  isUploading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const BulkImportFooter: React.FC<BulkImportFooterProps> = ({
  hasRows,
  totalValid,
  totalErrors,
  isUploading,
  onClose,
  onSubmit,
}) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:py-4 border-t border-slate-100 flex flex-col sm:flex-row gap-3 sm:gap-0 sm:items-center sm:justify-between bg-slate-50/50">
      <span className="text-[11px] sm:text-xs text-slate-500 text-center sm:text-left">
        {hasRows
          ? `${totalValid} buku siap impor, ${totalErrors} bermasalah`
          : 'Pilih file .csv untuk memulai'}
      </span>
      <div className="flex items-center justify-center sm:justify-end gap-3 w-full sm:w-auto">
        <button
          type="button"
          onClick={onClose}
          className="flex-1 sm:flex-none px-4 py-2 border border-slate-200 text-slate-600 font-semibold bg-white hover:bg-slate-50 rounded-xl text-xs transition cursor-pointer"
        >
          Batal
        </button>
        {hasRows && (
          <button
            type="button"
            disabled={isUploading || totalValid === 0}
            onClick={onSubmit}
            className="flex-1 sm:flex-none px-5 py-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-200 disabled:text-slate-400 disabled:cursor-not-allowed text-white font-semibold rounded-xl text-xs transition flex items-center justify-center gap-2 shadow-xs whitespace-nowrap cursor-pointer"
          >
            {isUploading ? (
              <>
                <Loader2 className="w-3.5 h-3.5 animate-spin" />
                <span>Mengimpor Massal...</span>
              </>
            ) : (
              <>
                <Check className="w-4 h-4" />
                <span>Proses Impor ({totalValid} Buku)</span>
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};
